<mat-dialog-content (click)="closeModal()" class="cursor-pointer">
    <img class="min-h-452px" [src]="imageUrl" [alt]="imageAlt">
</mat-dialog-content>


